var exports = {
  "wQ": "SudoVerificationModal.module__passkeyVerifying___cFBWNF",
  "hU": "SudoVerificationModal.module__unavailable___cFBWNF",
  "TJ": "SudoVerificationModal.module__unavailableTitle___cFBWNF",
  "$r": "SudoVerificationModal.module__unavailableBody___cFBWNF",
  "zc": "SudoVerificationModal.module__formError___cFBWNF",
  "kK": "SudoVerificationModal.module__passkeyHint___cFBWNF",
};

module.exports = exports;
